import script from "./Window03Trim.vue?vue&type=script&setup=true&lang=js"
export * from "./Window03Trim.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__